import { getCdpTitle } from '../../../core/util/seo';
import CDPInfoFactory from '../CDPInfoFactory';
import { BASE_URL } from '../../../config';
import { isEmptyArray } from '../../../core/util/array';
import { createLocationUrlFromLocation } from '../../../core/url/location';
import { isEmptyObject } from '../../../core/util/object';
import { formatLocationName } from '../../../core/util/location';

/* ============================================================================
 * START OPEN GRAPH UTILS BLOCK
 * ============================================================================ */
/**
 * The openGraph title.
 * See getCdpTitle
 * @param {object} location
 * @returns {string} ogTitle
 */
const ogTitle = location => getCdpTitle(location);

/**
 * Use for primary image on the CDP, URL only.
 * Priority order: (1) Clinic photo, (2) Clinic logo, (3) Brand logo, or (4) default Solv image
 * @param {object} location
 * @returns {string} ogImage
 */
const ogImage = location => {
  const { imageLinks } = location;
  if (!isEmptyObject(imageLinks)) {
    if (!isEmptyArray(imageLinks.image)) return imageLinks.image[0];
    if (!isEmptyArray(imageLinks.logo)) return imageLinks.logo[0];
  }

  return `${BASE_URL}/images/Default-Clinic-Photo.svg`;
};

/**
 * Use for to get the right alt for the ogImage
 * @param {object} location
 * @returns {string} ogImageAlt
 */
const ogImageAlt = location => {
  const locationName = formatLocationName(location, ', ');
  const { city, state } = location;
  return `${locationName} - ${city}, ${state}`;
};

/**
 * Full path CDP url
 * @param {object} location
 * @returns {string} ogUrl
 */
const ogUrl = location => BASE_URL + createLocationUrlFromLocation(location);

/**
 * Open Graph description
 * @param {object} location
 * @returns {string} ogDescription
 */
const ogDescription = location => {
  const CDPInfo = CDPInfoFactory.buildFromLocation(location);
  return CDPInfo.getDescription();
};

/* ============================================================================
 * END OPEN GRAPH UTILS BLOCK
 * ============================================================================ */

/* ============================================================================
 * START TWITTER CARD UTILS BLOCK
 * ============================================================================ */
/**
 * Open Graph description
 * @param {object} location
 * @returns {string} ogDescription
 */
const twitterDescription = location => ogDescription(location);

/* ============================================================================
 * END TWITTER CARD UTILS BLOCK
 * ============================================================================ */

export { ogDescription, ogImage, ogImageAlt, ogTitle, ogUrl, twitterDescription };
